import React from "react";
import { DEFAULT_PAGE_SIZE } from "../utils/listPagination";

/**
 * Shared prev/next pagination footer for server-paged admin tables.
 */
export default function PaginationFooter({
  page = 1,
  limit = DEFAULT_PAGE_SIZE,
  total = 0,
  totalPages = 0,
  onPageChange,
  itemLabel = "results",
  disabled = false,
}) {
  const safePage = Math.max(1, Number(page) || 1);
  const safeLimit = Math.max(1, Number(limit) || DEFAULT_PAGE_SIZE);
  const safeTotal = Math.max(0, Number(total) || 0);
  const safeTotalPages =
    Number(totalPages) > 0
      ? Number(totalPages)
      : safeTotal === 0
        ? 0
        : Math.max(1, Math.ceil(safeTotal / safeLimit));

  const from = safeTotal === 0 ? 0 : (safePage - 1) * safeLimit + 1;
  const to =
    safeTotal === 0 ? 0 : Math.min(safePage * safeLimit, safeTotal);

  const go = (next) => {
    if (disabled || typeof onPageChange !== "function") return;
    if (next < 1 || (safeTotalPages > 0 && next > safeTotalPages)) return;
    onPageChange(next);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between"
      style={{
        flexShrink: 0,
        minHeight: "60px",
        padding: "8px 4px",
      }}
    >
      <small style={{ color: "#77718b", fontSize: "13px" }}>
        {safeTotal > 0 && (
          <>
            Showing{" "}
            <strong style={{ color: "#403b55" }}>
              {from}
              {" – "}
              {to}
            </strong>{" "}
            of <strong style={{ color: "#403b55" }}>{safeTotal}</strong>{" "}
            {itemLabel}
          </>
        )}
        {safeTotal === 0 && <>No {itemLabel}</>}
      </small>

      <div className="d-flex align-items-center gap-2">
        <button
          type="button"
          className="btn"
          disabled={disabled || safePage <= 1 || safeTotal === 0}
          onClick={() => go(safePage - 1)}
          style={{
            backgroundColor:
              safePage <= 1 || safeTotal === 0 ? "#f4f2f7" : "#f2c4c4",
            border: "none",
            color: safePage <= 1 || safeTotal === 0 ? "#aaa5b5" : "#654343",
            fontWeight: "600",
            fontSize: "12px",
            padding: "8px 13px",
            borderRadius: "8px",
          }}
        >
          <i
            className="fa-solid fa-chevron-left"
            style={{ fontSize: "10px", marginRight: "5px" }}
          />
          Previous
        </button>

        <div
          style={{
            minWidth: "90px",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            color: "#403b55",
          }}
        >
          Page {safeTotal === 0 ? 0 : safePage} of {safeTotalPages}
        </div>

        <button
          type="button"
          className="btn"
          disabled={
            disabled ||
            safeTotal === 0 ||
            safePage >= safeTotalPages
          }
          onClick={() => go(safePage + 1)}
          style={{
            backgroundColor:
              safeTotal === 0 || safePage >= safeTotalPages
                ? "#f4f2f7"
                : "#bff1db",
            border: "none",
            color:
              safeTotal === 0 || safePage >= safeTotalPages
                ? "#aaa5b5"
                : "#355c4a",
            fontWeight: "600",
            fontSize: "12px",
            padding: "8px 13px",
            borderRadius: "8px",
          }}
        >
          Next
          <i
            className="fa-solid fa-chevron-right"
            style={{ fontSize: "10px", marginLeft: "5px" }}
          />
        </button>
      </div>
    </div>
  );
}
